import {
  ImpersonationHeaderDTO,
} from 'dtos';

declare const ImpersonationHeaderBrand: unique symbol;
export type ImpersonationHeader = string & {
  readonly [ImpersonationHeaderBrand]: typeof ImpersonationHeaderBrand;
};

export const IMPERSONATION_STORAGE_KEY = 'populate_impersonation';
const IMPERSONATION_HEADER_KEY = 'x-impersonation';

export class ImpersonationData implements ImpersonationHeaderDTO {
  constructor(
    public token: string,
    public userName: string,
    public userEmail: string,
    public expiresOnTimestamp: number,
  ) {
    // Constructor body intentionally empty - using parameter properties
  }

  public isExpired(): boolean {
    return Date.now() > this.expiresOnTimestamp;
  }

  public static fromHeader(header: ImpersonationHeader | null): ImpersonationData | null {
    if (!header) return null;
    try {
      const decoded = window.atob(header);
      const parsedHeader = JSON.parse(decoded) as ImpersonationHeaderDTO;
      const impersonationData = new ImpersonationData(
        parsedHeader.token,
        parsedHeader.userName,
        parsedHeader.userEmail,
        parsedHeader.expiresOnTimestamp,
      );
      return impersonationData;
    } catch (error) {
      return null;
    }
  }

  public static fromLoader(loader: () => ImpersonationHeader | null): ImpersonationData | null {
    return ImpersonationData.fromHeader(loader());
  }
}

export const loadImpersonationHeader = (): ImpersonationHeader | null => {
  const headerData = localStorage.getItem(IMPERSONATION_STORAGE_KEY) as ImpersonationHeader | null;
  if (!headerData) return null;
  return headerData;
};

export const saveImpersonationHeader = (data: ImpersonationHeader): void => {
  localStorage.setItem(IMPERSONATION_STORAGE_KEY, data);
};

export const deleteImpersonationHeader = (): void => {
  localStorage.removeItem(IMPERSONATION_STORAGE_KEY);
};

export const findImpersonationHeader = (
  headers: Record<string, string>,
): ImpersonationHeader | null => {
  const value = headers[IMPERSONATION_HEADER_KEY];
  return value ? (value as ImpersonationHeader) : null;
};

export const maybeAttachSavedImpersonationHeader = (headers: Record<string, string>): void => {
  const savedHeader = loadImpersonationHeader();
  if (savedHeader) {
    headers[IMPERSONATION_HEADER_KEY] = savedHeader;
  }
};
